import { render } from "./FPluginListadd.vue?vue&type=template&id=1d9a9d5b&scoped=true"
import script from "./FPluginListadd.vue?vue&type=script&lang=js"
export * from "./FPluginListadd.vue?vue&type=script&lang=js"

import "./FPluginListadd.vue?vue&type=style&index=0&id=1d9a9d5b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9a9d5b"]])

export default __exports__